import React from "react";

import { ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { DealsSection } from "@/types/deals.types";
import TableDragDivider from "@FillInTableContainer/shared/components/TableDragDivider/TableDragDivider";
import { useHandleTableCreatorSubGroupShellDrag } from "@FillInTableContainer/shared/hooks/useHandleTableCreatorSubGroupShellDrag";
import { TableCreatorSubGroupShellList } from "@FillInTableContainer/shared/types/tableCreator.types";
import { newArrayToCountValue } from "@utils/newArrayToCountValue";

import DealsKeyCommentMaSubGroupShell from "./components/DealsKeyCommentMaSubGroupShell/DealsKeyCommentMaSubGroupShell";
import * as S from "./DealsKeyCommentMaCreatorGroupShell.style";
import useCheckIsDisplaySubGroupShellDragDivider from "../../../../../DealsDealTermsTableCreatorContainer/components/DealTermsLicenseAgreementGroupTable/components/DealTermsLicenseAgreementTable/components/DealTermsLicenseAgreementGroupShellSection/components/DealTermsLicenseAgreementGroupShell/hooks/useCheckIsDisplaySubGroupShellDragDivider";
import { useGetNumberOfSupGroupShell } from "../../../../../DealsDealTermsTableCreatorContainer/components/DealTermsLicenseAgreementGroupTable/components/DealTermsLicenseAgreementTable/components/DealTermsLicenseAgreementGroupShellSection/components/DealTermsLicenseAgreementGroupShell/hooks/useGetNumberOfSubGroupShell";

const ARTICLE_SECTION = ENTRY_DATA_SECTION_KEYS.deals;

interface Props {
  groupTableKey: DealsSection;
  groupTableIndex: number;
  groupShellKey: string | null;
  groupShellIndex: number;
  subGroupShellList: TableCreatorSubGroupShellList;
  tableKey: string | null;
  tableIndex: number;
}

const DealsKeyCommentMaCreatorGroupShell = ({
  groupTableKey,
  groupTableIndex,
  groupShellKey,
  groupShellIndex,
  subGroupShellList,
  tableKey,
  tableIndex,
}: Props) => {
  const { subGroupShellCount } = useGetNumberOfSupGroupShell();

  const {
    handleSubGroupShellDragEnd,
    handleSubGroupShellDragOn,
    handleSubGroupShellDragOver,
    handleSubGroupShellDragStart,
    subGroupShellDraggedIndexInfo,
    isDraggingSubGroupShell,
  } = useHandleTableCreatorSubGroupShellDrag(ARTICLE_SECTION, tableIndex);

  const { isLastSubGroupShell, handleCheckDragDividerDisplay } =
    useCheckIsDisplaySubGroupShellDragDivider({
      tableIndex,
      groupShellIndex,
      isDraggingSubGroupShell,
    });

  return (
    <S.GroupShell>
      {subGroupShellList.map(({ subGroupShellKey, shellList }) =>
        newArrayToCountValue(
          subGroupShellCount(subGroupShellKey, tableIndex, groupShellIndex),
        ).map((_, subGroupShellIndex) => (
          <S.DraggableSubGroupShellWrapper
            key={`subGroupShell-${String(groupTableIndex)}-${String(
              tableIndex,
            )}-${String(subGroupShellIndex)}`}
            isTargetDraggingTable={
              isDraggingSubGroupShell &&
              subGroupShellDraggedIndexInfo[0] !== subGroupShellIndex
            }
            onDragOver={(event) =>
              handleSubGroupShellDragOver(event, subGroupShellIndex)
            }
          >
            <TableDragDivider
              isDraggingEndPosition={handleCheckDragDividerDisplay({
                moveDragIndex: subGroupShellDraggedIndexInfo[1],
                startDragIndex: subGroupShellDraggedIndexInfo[0],
                subGroupShellIndex,
                subGroupShellKey,
              })}
            />
            <DealsKeyCommentMaSubGroupShell
              groupTableKey={groupTableKey}
              groupTableIndex={groupTableIndex}
              groupShellKey={groupShellKey}
              groupShellIndex={groupShellIndex}
              subGroupShellKey={subGroupShellKey}
              subGroupShellIndex={subGroupShellIndex}
              subGroupShellCount={subGroupShellCount(
                subGroupShellKey,
                tableIndex,
                groupShellIndex,
              )}
              shellList={shellList}
              tableKey={tableKey}
              tableIndex={tableIndex}
              handleDragStart={handleSubGroupShellDragStart}
              handleDragEnd={handleSubGroupShellDragEnd}
              handleDragOn={handleSubGroupShellDragOn}
            />
            {isLastSubGroupShell(subGroupShellIndex, subGroupShellKey) && (
              <TableDragDivider
                isDraggingEndPosition={handleCheckDragDividerDisplay({
                  moveDragIndex: subGroupShellDraggedIndexInfo[1],
                  startDragIndex: subGroupShellDraggedIndexInfo[0],
                  subGroupShellIndex,
                  subGroupShellKey,
                  lastIndex: newArrayToCountValue(
                    subGroupShellCount(
                      subGroupShellKey,
                      tableIndex,
                      groupShellIndex,
                    ),
                  ).length,
                })}
              />
            )}
          </S.DraggableSubGroupShellWrapper>
        )),
      )}
    </S.GroupShell>
  );
};

export default DealsKeyCommentMaCreatorGroupShell;
